module.exports = __webpack_public_path__ + "static/media/shopee_logo.3e9a7ee1.png";